import React from 'react';
import RenderError from '../../components/RenderError';

function CurrentPracticesCropsQuestion({
  crops,
  formData,
  setFormData,
  handleCheckCrop,
  handleCropInputChange,
  errors
}) {
  return (
    <div className="form__field form__field--required">
      <label className="form__label">
        What crop(s) do you plan to treat with the propane-fueled flame weed
        control system?
      </label>
      <p>
        For each crop, please include the number of acres you plan to treat.
        Please specify what percentage, if any, of these acres are organic.
      </p>
      {errors.cropsToTreat && (
        <RenderError error={errors.cropsToTreat.cropsToTreat} />
      )}
      {Object.values(crops).map((crop) => (
        <div key={crop}>
          <label
            className="form__checkbox u--display-flex u--justify-content-flex-end"
            style={{ gap: '2rem' }}
          >
            <input
              type="checkbox"
              value={crop}
              checked={crop in formData.cropsToTreat}
              onChange={handleCheckCrop}
            />
            <span style={{ flexGrow: 1 }}>{crop}</span>
            <div
              className={`u--display-${
                crop in formData.cropsToTreat ? 'flex' : 'none'
              } u--flex-direction-column`}
            >
              <small>Number of Acres</small>
              <input
                type="number"
                value={
                  formData.cropsToTreat[crop] &&
                  formData.cropsToTreat[crop].acres
                    ? formData.cropsToTreat[crop].acres
                    : ''
                }
                name="acres"
                onChange={(event) => handleCropInputChange(event, crop)}
              />
              {errors.cropsToTreat &&
                errors.cropsToTreat.hasOwnProperty(crop) && (
                  <RenderError error={errors.cropsToTreat[crop].acres} />
                )}
            </div>
            <div
              className={`u--display-${
                crop in formData.cropsToTreat ? 'flex' : 'none'
              } u--flex-direction-column`}
            >
              <small>% Organic</small>
              <input
                type="number"
                value={
                  formData.cropsToTreat[crop] &&
                  formData.cropsToTreat[crop].percentOrganic
                    ? formData.cropsToTreat[crop].percentOrganic
                    : 0
                }
                name="percentOrganic"
                onChange={(event) => handleCropInputChange(event, crop)}
              />
              {errors.cropsToTreat &&
                errors.cropsToTreat.hasOwnProperty(crop) && (
                  <RenderError
                    error={errors.cropsToTreat[crop].percentOrganic}
                  />
                )}
            </div>
          </label>
          {crop in formData.cropsToTreat &&
            (crop === 'Other (please specify)' ? (
              <div className="u--margin-top-10 u--margin-left-10">
                <input
                  type="text"
                  name="Other (please specify)"
                  value={formData.cropsToTreat[crop].crop}
                  onChange={(event) => {
                    setFormData({
                      ...formData,
                      cropsToTreat: {
                        ...formData.cropsToTreat,
                        [event.target.name]: {
                          ...formData.cropsToTreat[crop],
                          crop: event.target.value
                        }
                      }
                    });
                  }}
                  className="form__input form__input--lg u--width-100"
                />
                {errors.cropsToTreat &&
                  errors.cropsToTreat.hasOwnProperty(crop) && (
                    <RenderError error={errors.cropsToTreat[crop].crop} />
                  )}
              </div>
            ) : (
              ''
            ))}
        </div>
      ))}
    </div>
  );
}

export default CurrentPracticesCropsQuestion;
